import { useParams } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import SectionTitle from '../../../../../components/Text/SectionTitle';
import StudentTabsHeader from '../StudentTabsHeader';
import { useTexts } from './hooks/useTexts';
import { TutorsLoader } from './parts/TutorsLoader';
import { TutorsTable } from './parts/TutorsTable';

export function StudentTutors() {
  const texts = useTexts();
  const { studentId } = useParams<{ studentId: string }>();

  return (
    <TutorsLoader studentId={studentId}>
      {({ data }) => (
        <>
          <StudentTabsHeader
            id={data.studentPlansAndTutors.student.rut}
            name={data.studentPlansAndTutors.student.fullName}
          />
          <Col className="my-4">
            <Row>
              <SectionTitle text={texts.sectionTitle} />
            </Row>
          </Col>
          <TutorsTable tutorsData={data} />
        </>
      )}
    </TutorsLoader>
  );
}
